<template>
  <el-table
    :data="countTable"
    border
    :span-method="objectSpanMethod"
		style="width: 100%"
    :maxHeight="maxHeight"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column prop="memberGradeName" label="会员等级" align="center" />
    <el-table-column prop="amountRange" label="金额区间" align="center" min-width="110"/>
    <el-table-column prop="paymentCount" label="付款人数" align="center" />
    <el-table-column
      prop="paymentCountRatioStr"
      label="付款人数占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="paymentAmount" label="付款金额" align="center" />
    <el-table-column
      prop="paymentAmountRatioStr"
      label="付款金额占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="paymentOrderCount" label="付款单量" align="center" />
    <el-table-column
      prop="paymentOrderCountRatioStr"
      label="付款单量占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="paymentItemCount" label="付款件数" align="center" />
    <el-table-column
      prop="paymentItemCountRatioStr"
      label="付款件数占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="customerUnitPrice" label="客单价" align="center" />
    <el-table-column prop="orderUnitPrice" label="笔单价" align="center" />
    <el-table-column prop="itemUnitPrice" label="件单价" align="center" />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
	mixins: [mixins],
  components: {
    Empty,
  },
	props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
	computed: {
    countTable() {
      return this.tableData;
    },
  },
  methods: {
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const current = this.countTable[rowIndex].memberGrade;
        const prev = this.countTable[rowIndex - 1] ? this.countTable[rowIndex - 1].memberGrade : null;
        // 如果和上一行相同
        // 当前单元格隐藏
        if (current === prev) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        // 计算需要合并多少行
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.countTable.length; i++) {
          if (this.countTable[i].memberGrade === current) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
    },
  },
};
</script>
